module.exports = __webpack_public_path__ + "static/media/flag-ga.5411f0c2.webp";